<template>
  <b-container fluid>
    <iq-card>
        <template>
            <b-row v-if="reportHeadData">
                    <b-col xs="12" sm="12" md="12" class="text-right">
                        <b-button-group>
                            <b-button variant="success" @click="pdfExport">
                                <i style="font-size: 18px; margin: 0; padding: 0;" class="ri-printer-fill"></i>
                            </b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
            <!-- report head data -->
            <b-row v-if="reportHeadData">
                <b-col xs="12" sm="12" md="3" class="text-right mt-3">
                    <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                </b-col>
                <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                    <h3 class="text-bold">
                        {{ $t('production_store.govt_info') }}
                    </h3>
                    <h4 class="text-center text-dark">
                        {{ $t('social_service.dss') }}
                    </h4>
                    <!-- <span class="text-center text-dark">
                        {{ reportHeadData.heading }}
                    </span><br> -->
                    <span class="text-center text-dark">
                        {{ reportHeadData.address }}
                    </span><br>
                    <div class="titleDiv">
                        <span class="text-center text-dark reportTitle" style="font-weight:bold;">
                            {{ $t('report.good_stock_register') }}
                        </span><br>
                    </div>
                </b-col>
                <b-col xs="12" sm="12" md="3" class="text-left mt-3">
                      <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
                </b-col>
            </b-row>
            <!-- report head data -->
            <b-row class="details_report mt-4" v-if="reportHeadData">
              <b-col lg="12" sm="12">
                <b-row class="mb-1">
                  <b-col lg="12" sm="12">
                    <div class="col-md-12">
                      <!-- <h5 class="font-weight-bold text-capitalize text-center p-1">{{ $t('report.good_stock_register') }}</h5> -->
<h4 class="font-weight-bold  text-left">{{ $t('report_monthly.workplace_name') }}: {{ getHospitalName(data.hospital_id) }}</h4>
<h4 class="font-weight-bold  text-left">{{ $t('report_monthly.month_name') }}: {{ getMonthName(data.month_id) }}</h4>
                      <b-table-simple  bordered hover responsive class="mt-2">
                        <b-tr  >
                          <b-th>{{ $t('report.sl_no_tarikh') }}</b-th>
                          <b-th>{{ $t('report.goods_name') }}</b-th>
                          <b-th>{{ $t('report.previous_stock') }}</b-th>
                          <b-th>{{ $t('report.new_receipt') }}</b-th>
                          <b-th>{{ $t('report.total_amount') }}</b-th>
                          <b-th>{{ $t('report.distribution') }}</b-th>
                          <b-th>{{ $t('report.rest') }}</b-th>
                        </b-tr>
                        <b-tr>
                          <b-th>{{ $n(1) }}</b-th>
                          <b-th>{{ $n(2) }}</b-th>
                          <b-th>{{ $n(3) }}</b-th>
                          <b-th>{{ $n(4) }}</b-th>
                          <b-th>{{ $n(5) }}</b-th>
                          <b-th>{{ $n(6) }}</b-th>
                          <b-th>{{ $n(7) }}</b-th>
                        </b-tr>
                        <b-tr v-for="(item, index) in resultList.data" :key="index">
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                            {{index | dateFormat}}
                            </b-th>
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                              <span v-for="(itemx, index2) in hosItemList" :key="index2">
                                <span v-if="sum(item, itemx.value) > 0">
                                    {{ getItemName(itemx.value) }}<hr>
                                </span>
                              </span>
                            </b-th>
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                              <span v-for="(itemx, index2) in hosItemList" :key="index2">
                                <span v-if="sum(item, itemx.value) > 0">
                                  {{ $n(prevSum(index, itemx.value)) }}<hr>
                                </span>
                              </span>
                            </b-th>
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                              <span v-for="(itemx, index2) in hosItemList" :key="index2">
                                <span v-if="sum(item, itemx.value) > 0">
                                  {{ $n(sum(item.filter(item => item.donation_in_type === 1), itemx.value)) }}<hr>
                                </span>
                              </span>
                            </b-th>
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                              <span v-for="(itemx, index2) in hosItemList" :key="index2">
                                <span v-if="sum(item, itemx.value) > 0">
                                  {{ $n(prevSum(index, itemx.value) + sum(item.filter(item => item.donation_in_type === 1), itemx.value)) }}<hr>
                                </span>
                              </span>
                            </b-th>
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                              <span v-for="(itemx, index2) in hosItemList" :key="index2">
                                <span v-if="sum(item, itemx.value) > 0">
                                  {{ $n(sum(item.filter(item => item.donation_out_type === 1), itemx.value)) }}<hr>
                                </span>
                              </span>
                            </b-th>
                            <b-th v-if="isIndexInRange(index, firstday(), lastday())">
                              <span v-for="(itemx, index2) in hosItemList" :key="index2">
                                <span v-if="sum(item, itemx.value) > 0">
                                  {{ $n(prevSum(index, itemx.value) + sum(item.filter(item => item.donation_in_type === 1), itemx.value) - sum(item.filter(item => item.donation_out_type === 1), itemx.value)) }}<hr>
                                </span>
                              </span>
                            </b-th>
                        </b-tr>
                      </b-table-simple>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
        </template>
    </iq-card>
  </b-container>
</template>
<script>
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { materialReportApi } from '../../../api/routes'
import ReportHeading from '@/Utils/report-head'
import ExportPdf from './export-pdf-details'

export default {
  props: ['data'],
  emits: ['load'],
    data () {
        return {
              search: {
                division_id: 0,
                district_id: 0,
                upazilla_id: 0,
                hospital_id: 0,
                month_id: 0,
                fiscal_year_id: 0
              },
            editItemId: '',
            item: '',
            districtList: [],
            upazilaList: [],
            upazillaList: [],
            hospitalList: [],
            resultList: [],
            reportHeadData: null,
            search_report: {
              workplace_name: ' ',
              month_name: ' '
            }
        }
      },
   computed: {
    hosItemList: function () {
        return this.$store.state.HospitalDisabilityService.commonObj.hosItemList.filter(item => item.status === 1)
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    yearList: function () {
      const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
      const years = data.map((obj, key) => {
        const year = obj.text.split('-')[0]
        return { value: obj.text_en.split('-')[1], text: year }
      })
      // Getting the last year on the end of the Fiscal Year List
      const lastYear = (data[data.length - 1].text.split('-')[1])
      years.push({ value: lastYear, text: lastYear })
      return years
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    formTitle () {
      return this.$t('report.mat_repo') + ' ' + this.$t('hospital_public_panel.report')
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    /** Used to get month name in title data */
    'search.month_id': function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.titleData.month_name = this.getMonthName(newVal)
      }
    },
    'search.division_id': function (newVal, oldVal) {
      this.search.district_id = 0
      this.districtList = this.getDistrictList(newVal)
    },
    'search.district_id': function (newVal, oldVal) {
      this.search.upazilla_id = 0
      this.upazillaList = this.getupazillaList(newVal)
    },
    'search.upazilla_id': function (newVal, oldVal) {
      // Reset both hospital id & list
      this.search.hospital_id = 0
      if (newVal !== 0) {
        this.hospitalList = this.getHospitalListByUpazillaId(newVal)
      } else if (newVal === 0) {
        this.hospitalList = this.getHospitalListAll()
      }
    }
  },
  created () {
      if (this.data) {
        this.loadData()
      }
      this.headerName()
      this.hospitalList = this.getHospitalListAll()
  },
  methods: {
    isIndexInRange (index, firstdate, lastdate) {
      return index >= firstdate && index <= lastdate
    },
    firstday () {
      const year = this.data.month_id > 6 ? this.data.fiscal_year_id - 1 : this.data.fiscal_year_id
      const month = this.data.month_id.toString().padStart(2, '0')
      return `${year}-${month}-01`
    },
    lastday () {
      const nextMonth = this.data.month_id === 12 ? 1 : this.data.month_id + 1
      const year = this.data.month_id > 6 ? this.data.fiscal_year_id - 1 : this.data.fiscal_year_id
      const nextMonthStr = nextMonth.toString().padStart(2, '0')
      return `${year}-${nextMonthStr}-01`
    },
    sum (data, itemId) {
        let stkIn = 0
        Object.values(data).map(search => {
              if (search.item_id === itemId) {
                stkIn += parseInt(search.quantity)
              }
        })
        return parseInt(stkIn)
    },
     prevSum (date, itemId) {
        let stkIn = 0
        let stkOut = 0
        Object.values(this.resultList.data).forEach(search => {
            search.forEach(value2 => {
              if (value2.item_id === itemId) {
                  const valueDate = new Date(value2.date)
                  if (valueDate < new Date(date)) {
                      stkIn += (value2.donation_in_type === 1) ? parseInt(value2.quantity) : 0
                      stkOut += (value2.donation_out_type === 1) ? parseInt(value2.quantity) : 0
                  }
              }
            })
        })
        return stkIn - stkOut
    },
    getItemName (Id) {
      const obj = this.$store.state.HospitalDisabilityService.commonObj.hosItemList.find(item => item.value === Id)
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    item_name (data) {
      let p = 0
      let x = ''
      data.map(search => {
          if (p !== search.item_name) {
            x = search.item_name
          } else {
            x = ''
          }
          p = x
      })
      return x
    },
    ps_stk_in (data, itmId) {
      let stkIn = 0
      data.map(search => {
            if (search.donation_in_type === 1 && search.item_id === itmId) {
              stkIn += parseInt(search.quantity)
            }
        })
        return parseInt(stkIn)
    },
    stk_in (data, itmId) {
      let stkIn = 0
      data.map(search => {
            if (search.donation_in_type === 1 && search.item_id === itmId) {
              stkIn += parseInt(search.quantity)
            }
        })
        return parseInt(stkIn)
    },
    stk_out (data, itmId) {
      let stkOut = 0
      data.map(search => {
            if (search.donation_out_type > 0 && search.item_id === itmId) {
              stkOut += parseInt(search.quantity)
            }
        })
        return parseInt(stkOut)
    },
    getDistrictList (divisionId = null) {
      return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
    },
    getupazillaList (districtId = null) {
      return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getHospitalListByUpazillaId: function (upazillaId = null) {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.upazilla_id === upazillaId)
    },
    getHospitalListAll: function () {
      return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
    },
    getMonthName (Id) {
      const obj = this.$store.state.commonObj.monthList.find(item => item.value === Id)
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    getHospitalName (Id) {
      const obj = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === Id)
      if (obj === undefined) {
        return ''
      } else {
        return this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en
      }
    },
    searchData () {
        this.loadData()
    },
    async headerName () {
      const result = await ReportHeading.getReportHead(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3)
      this.reportHeadData = result
    },
    // --- Load ---
        async loadData () {
            this.is_view_material_report = true
            const result = await RestApi.getData(hospitalServiceBaseUrl, materialReportApi, this.data)
            this.resultList = result
        },
       async pdfExport () {
            const reportTitle = this.$t('report.good_stock_register')
            const data = this.resultList.data
            const titleData = { workplace_name: this.getHospitalName(this.data.hospital_id), month_name: this.getMonthName(this.data.month_id) }
            this.loadingPdf = true
            await ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this, titleData)
            this.loadingPdf = false
        }
    }
  }
</script>
<style lang="scss">
  .titleDiv {
    font-size: 18px;
  }
  .details_report {
    font-size: 8px;
    color: #000;
    h5 {
      color: green !important;
      font-size: 12px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
    .table-bordered th {
      text-align: center;
      font-size: 11px !important;
      // font-weight: 900 !important;
    }
    .table-bordered tr td {
      font-size: 9px !important;
      text-align: center;
    }
  }
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
